export const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const monthNamesValues = monthNames.map((m) => m.toUpperCase());
